import React from 'react';
import Checkbox from '../../forms/Checkbox';
import Input from '../../forms/Input';
import FormSetting from '../../layout/FormSetting';
import { QuestRoute } from '../../api/QuestRoutes';
import Select from '../../forms/Select';
import { HSOptions } from '../../../constants/HSOptions';
import HamQuest from '../../api/HamQuestGiver';
import { userRoles } from '../../RoleProtected';
import Row from '../../layout/Row';
import PhoneNumberInput from '../../forms/formComponents/PhoneNumberInput';
import { HasFeature, Features } from '../../RequireFeature';

const Settings = ({ children, ...props }) => {

    const HasNewMaxUses = HasFeature(Features.NewMaxUses);
    return (
        <FormSetting
            label='Settings'
            getInputs={QuestRoute.washClubs.settings}
            onSubmit={e => {
                e.washClubTime = e.washClubTime * 60;
                return HamQuest.put(QuestRoute.washClubs.settings, { ...e })
            }}
            callback={res => {
                res.washClubTime = Math.floor(res.washClubTime / 60)
                return res
            }}
            text='Update'
            name='washClubSettings'
            editable
            roles={userRoles.editProducts}
        >
            {({ values }) => (

                <>
                    <Input
                        label='Wash Club Name'
                        name='programName'
                        required
                    />

                {!HasNewMaxUses &&
                <>
                    <Row wrap>
                        <Select
                            label='Max Use Period'
                            name='passMaxUsePeriod'
                            options={HSOptions.washClub.period}
                            required
                        />
                        <Input
                            label='Max Uses'
                            name='passMaxUses'
                            type='number'
                            required
                        />
                    </Row>

                    <Row wrap>
                        <Select
                            label='App Scan Max Use Period'
                            name='appIdPassMaxUsePeriod'
                            options={HSOptions.washClub.period}
                            required
                        />
                        <Input
                            label='App Scan Max Uses'
                            name='appIdPassMaxUses'
                            type='number'
                            required
                        />
                    </Row>



                    <Row wrap>
                        <Select
                            label='App Scan Timer Max Use Period'
                            name='appIdPassMaxTimerUsePeriod'
                            options={HSOptions.washClub.period}
                            required
                        />
                        <Input
                            label='App Scan Timer Max Uses'
                            name='appIdPassMaxTimerUses'
                            type='number'
                            required
                        />
                    </Row>
                    </>
                    }


                    <Input
                        label='Pass Reuse Inhibit Time (min)'
                        name='passReuseInhibitTime'
                        type='number'
                        required
                    />

                    <Select
                        label='Receipt Mode'
                        name='receiptMode'
                        options={HSOptions.washClub.receiptMode}
                        required
                    />

                    <Row wrap>
                        <Input
                            label='Wash Club Support Email'
                            name='supportEmail'
                            required
                        />

                        <PhoneNumberInput
                            label='Wash Club Support Phone'
                            name='supportPhone'
                        />
                    </Row>

                    <Checkbox
                        label='Display Use Count'
                        name='displayUseCount'
                    />
                    <Checkbox
                        label='Wash Club Time Enabled'
                        name='washClubTimeEnabled'
                    />

                    <Input
                        label='Wash Club Time (min)'
                        name='washClubTime'
                        type='number'
                        required
                    />
                </>
            )}
        </FormSetting>
    );
}

export default Settings;
